import script from "./CommentEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./CommentEditModal.vue?vue&type=style&index=0&id=68a628d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a628d2"]])

export default __exports__